<header>
    <dx-toolbar class="header-toolbar">
        <dxi-item *ngIf="menuToggleEnabled" location="before" widget="dxButton" cssClass="menu-button" [options]="{
                icon: 'menu',
                stylingMode: 'text',
                onClick: toggleMenu
            }">
        </dxi-item>
        <dxi-item location="before" cssClass="header-title" *ngIf="title" [text]="title">
        </dxi-item>     

        <dxi-item location="before" 
            widget="dxButton" 
            locateInMenu="never"
            [options]="helpButtonOptions">   
        </dxi-item>  

        <dxi-item location="after"  
            *ngIf="isWorksheetLoaded()"
            widget="dxButton" 
            locateInMenu="never">
            <div *dxTemplate>
                <div>Layout: </div>
            </div>        
        </dxi-item>

        <dxi-item 
            *ngIf="isWorksheetLoaded()"
            location="after"
            locateInMenu="auto"
            widget="dxSelectBox"
            [options]="selectBoxOptions">
        </dxi-item>
            
        <dxi-item *ngIf="!isLoggedIn" 
            location="after" 
            locateInMenu="never"
            cssClass="login-button" 
            widget="dxButton"
            [options]="loginButtonOptions">
        </dxi-item>

        <dxi-item *ngIf="isLoggedIn" 
            location="after" 
            locateInMenu="never"
            cssClass="login-button" 
            widget="dxDropDownButton"
            [options]="userSettingsButtonOptions">
    </dxi-item>

        <dxi-item *ngIf="isLoggedIn" 
            location="after" 
            locateInMenu="never"
            cssClass="logout-button" 
            widget="dxButton"
            [options]="logoffButtonOptions">
        </dxi-item>
    </dx-toolbar>

    <dx-popup
        [width]="600"
        [height]="400"
        title="About {{appName}}"
        [showTitle]="true"
        [dragEnabled]="false"
        [closeOnOutsideClick]="true"
        [(visible)]="showAbout">
            <div>
                <label class="about-text">Version: {{version}}</label>
            </div>

            <div>
                <label class="about-text">Released: {{releasedDate}}</label>
            </div>

            <div>
                <label class="about-text">Copyright (c) 2020 - All rights reserved</label>
            </div>

            <div class="about-disclaimer-text">{{appName}} is provided "as-is", without any warranty, or fitness of produced results for a particular purpose.  Usage
                    of {{appName}} indicates acceptance of the above term(s) and conditions.  It is the responsibility of the user to validate and verify any data produced
                    by {{appName}}.  In no event shall the developer be held liable for any damages arising from use of {{appName}}.
            </div>
  </dx-popup>

  <dx-popup
    [width]="600"
    [height]="390 "
    title="{{appName}} User Login"
    [showTitle]="true"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="showLoginDialog">
        <dx-validation-group id="login-validation-group">
            <div class="dx-field-label login-field-label" >
                User Name: 
            </div>
            <div class="dx-field login-field-value">
                <dx-text-box class="login-field-textbox"  [(value)]="userModel.username" (onEnterKey)="onLoginEnterKey($event)">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="User Name is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            
            <div class="dx-field-label login-field-label" >
                Password: 
            </div>
            <div class="dx-field login-field-value">
                <dx-text-box class="login-field-textbox" mode="password" [(value)]="userModel.password"(onEnterKey)="onLoginEnterKey($event)">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>  

            <div class="login-errormsg-div" *ngIf="showErrorMsg">
                {{errorMsg}}
            </div>

            <div class="login-button-div">
                <dx-button id="login-submit-button" class="login-button" type="default" text="Login" (onClick)="onLoginClicked($event)" width="120px"></dx-button>
                <dx-button  class="login-button"  text="Cancel" (onClick)="onCancelClicked($event)" width="120px"></dx-button>
            </div>      

            <div class="login-register-div">
            </div>
        </dx-validation-group>
    </dx-popup>

    <dx-popup
    [width]="800"
    [height]="480"
    title="Change Password"
    [showTitle]="true"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="showChangePasswordDialog">
        <dx-validation-group id="password-validation-group">
            <div class="reset-password-div" *ngIf="isForcedChangePassword">
                Passwords for new accounts or passwords that have been reset must be changed by the user the first time logging in.  
                Passwords must be at least 8 characters long and contain at least one number and one special character.
            </div>

            <div class="reset-password-div" *ngIf="!isForcedChangePassword">
                Passwords must be at least 8 characters long and contain at least one number and one special character.
            </div>

            <div class="dx-field-label login-field-label" >
                Old Password: 
            </div>
            <div class="dx-field login-field-value">
                <dx-text-box class="login-field-textbox" mode="password" [(value)]="resetPasswordModel.oldPassword" (onEnterKey)="onResetPasswordEnterKey($event)">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Old password is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>  

            <div class="dx-field-label login-field-label" >
                New Password: 
            </div>
            <div class="dx-field login-field-value">
                <dx-text-box class="login-field-textbox" mode="password" [(value)]="resetPasswordModel.newPassword" (onEnterKey)="onResetPasswordEnterKey($event)">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="New password is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>  

            <div class="dx-field-label login-field-label" >
                Confirm Password: 
            </div>
            <div class="dx-field login-field-value">
                <dx-text-box class="login-field-textbox" mode="password" [(value)]="resetPasswordModel.confirmPassword" (onEnterKey)="onResetPasswordEnterKey($event)">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Confirm password is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>  

            <div class="login-errormsg-div" *ngIf="showErrorMsg">
                {{errorMsg}}
            </div>

            <div class="login-button-div">
                <dx-button id="reset-password-submit-button" class="login-button" type="default" text="OK" (onClick)="onResetPasswordClicked($event)" width="120px"></dx-button>
                <dx-button  class="login-button"  text="Cancel" (onClick)="onCancelResetPasswordClicked($event)" width="120px"></dx-button>
            </div>      

       
        </dx-validation-group>
    </dx-popup>
</header>